var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-polyline',{attrs:{"latLngs":_vm.myPath,"color":_vm.color,"weight":_vm.weight}})}
var staticRenderFns = []

export { render, staticRenderFns }